'use strict'

import $ from 'jquery';
import * as Backbone from 'backbone';
import * as Marionette from 'backbone.marionette';
import * as _ from 'underscore';
import * as Bootstrap from 'bootstrap';

import tpl_shopListItem from './tpl/shopListItem.html';
import language from '../../../common/language';
import config from '../../../common/config';

export default Marionette.ItemView.extend({
    tagName: 'li',
    getTemplate: function () {
        return tpl_shopListItem({ model: this.model.toJSON() });
    },
    initialize: function () {
        this.app = this.options.app;
    },
    ui: {
        'shopListItem_btnAddCart' : '#shopListItem_btnAddCart'
    },
    events: {
        'click @ui.shopListItem_btnAddCart': 'btnAddCart'
    },
    onRender: function () {
    },
    btnAddCart: function (event) {
        event.preventDefault();

        var userChannel = Backbone.Radio.channel('app');
        userChannel.trigger('menu:shopProduct', this.model);
    }
}, Backbone.Radio.Requests);